module.exports = __webpack_public_path__ + "img/exigence-supplementaire.66d2ef99.svg";